module.exports = __webpack_public_path__ + "static/media/9.4bc92417.png";